import React from "react";

const Footer = () => (
  <div className="footer">
    <p>This app is created by <b>Avinash Anand</b></p>
  </div>
);

export default Footer;